import router from '@/router';

const OCRoutes = [
  {
    path: 'admin/ceas',
    name: 'Cea',
    component: {
      name: 'AdminCea',
      render(h) {
        return h('router-view');
      },
    },
    meta: {
      resource: 'cea',
    },
    get redirect() {
      return this.children[0];
    },
    children: [
      {
        path: '',
        name: 'AdminCeaIndex',
        component: () => import('../views/CeasIndex.vue'),
        meta: {
          backRoute: { name: 'dashboard' },
        },
      },
      {
        path: 'new',
        name: 'AdminCeaNew',
        component: () => import('../views/CeaInput.vue'),
        meta: {
          action: 'new',
          backRoute: { name: 'AdminCeaIndex' },
        },
      },
      {
        path: ':id(\\d+)',
        name: 'AdminCeaShow',
        component: () => import('../views/CeaShow.vue'),
        meta: {
          backRoute: {
            name: 'AdminCeaIndex',
          },
          tArgs: route => ({ name: route?.params?.id }),
        },
        get redirect() {
          return this.children[0];
        },
        children: [
          {
            path: '',
            name: 'AdminCeaDetails',
            component: () => import('../views/CeaDetails.vue'),
            meta: {
              backRoute: { name: 'AdminCeaIndex' },
            },
          },
          {
            path: 'edit',
            name: 'AdminCeaEdit',
            component: () => import('../views/CeaInput.vue'),
            meta: {
              action: 'edit',
              backRoute: { name: 'AdminCeaDetails' },
            },
          },

          /* CEA Special Days Tab */
          {
            path: 'cea_special_days',
            name: 'AdminCeaSpecialDays',
            component: {
              name: 'AdminCeaSpecialDay',
              render(h) {
                return h('router-view');
              },
            },
            get redirect() {
              return this.children[0];
            },
            meta: {
              backRoute: { name: 'AdminCeaIndex' },
              resource: 'cea_special_day',
            },
            children: [
              {
                path: '',
                name: 'AdminCeaSpecialDay',
                component: () => import('../views/ceaSpecialDay/CeaCeaSpecialDays.vue'),
                meta: {
                  backRoute: { name: 'AdminCeaIndex' },
                },
              },
              {
                path: 'new',
                name: 'AdminCeaSpecialDayNew',
                component: () => import('../views/ceaSpecialDay/CeaSpecialDayInput.vue'),
                meta: {
                  action: 'new',
                  backRoute: { name: 'AdminCeaSpecialDays' },
                },
              },
              {
                path: ':ceaSpecialDayId(\\d+)',
                name: 'AdminCeaSpecialDayShow',
                component: () => import('../views/ceaSpecialDay/CeaSpecialDayShow.vue'),
                meta: {
                  backRoute: {
                    name: 'AdminCeaSpecialDays',
                  },
                  tArgs: route => ({ name: route?.params?.ceaSpecialDayId }),
                },
                get redirect() {
                  return this.children[0];
                },
                children: [
                  {
                    path: '',
                    name: 'AdminCeaSpecialDayDetails',
                    component: () => import('../views/ceaSpecialDay/CeaSpecialDayDetails.vue'),
                    meta: {
                      backRoute: { name: 'AdminCeaSpecialDays' },
                    },
                  },
                  {
                    path: 'edit',
                    name: 'AdminCeaSpecialDayEdit',
                    component: () => import('../views/ceaSpecialDay/CeaSpecialDayInput.vue'),
                    meta: {
                      action: 'edit',
                      backRoute: { name: 'AdminCeaSpecialDayDetails' },
                    },
                  },
                ]
              }
            ],
          },
        ],
      },
    ]
  },
];

OCRoutes.forEach(route => router.addRoute('OC', route));